var render = function render(){var _vm=this,_c=_vm._self._c;return _c('x-err-dialog',{attrs:{"visible":_vm.visible,"close-on-click-mask":""}},[_c('div',{staticClass:"book-catalog-type-wrap"},[_vm._l((_vm.list),function(item){return [_c('p',{key:item.id,staticClass:"catalog-type-item",on:{"click":function($event){return _vm.selectTitle(item)}}},[_vm._v(_vm._s(item.volumeTitle))])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }